import { boardSwitcherSharedState } from '@trello/board-switcher';

export const getBoardSwitcherSource = () => {
  const { mode } = boardSwitcherSharedState.value;

  if (mode === 'panel') {
    return 'boardSwitcherPanel';
  }

  return 'boardSwitcherModal';
};
